var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.$style.container,attrs:{"href":_vm.portalUrl}},[(_vm.$mq.phone)?_c('img',{class:_vm.$style.logoImage,attrs:{"src":require("@images/bilderlings-logo-short.svg"),"alt":""}}):_c('img',{class:_vm.$style.logoImage,attrs:{"src":require("@images/bilderlings-logo.svg"),"alt":""}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f20fadd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","vector":"src"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Logo.vue
// module id = dyNY
// module chunks = 0